import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-device",
  "use": "rt-base-device-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-base-device\">\n<path d=\"M796.4,307.8c0-40.9-40.6-40.9-40.6-40.9H268.2c0,0-40.6,0-40.6,40.9v40.9h568.8L796.4,307.8L796.4,307.8z M674.5,185.2\n\th-325c0,0-40.6,0-40.6,40.9h406.3C715.1,185.2,674.4,185.2,674.5,185.2L674.5,185.2L674.5,185.2z M877.6,348.7l-24-24.2v65.1H170.3\n\tv-65.1l-24,24.2c-24,24.2-41.3,30.7-31.6,81.8c9.6,50.9,56.3,330.1,63.1,367.8c7.6,41.4,49.7,40.9,49.7,40.9h568.8\n\tc0,0,42,0.6,49.7-40.9c6.9-37.8,53.5-316.9,63.2-367.8C918.9,379.4,901.7,372.9,877.6,348.7L877.6,348.7L877.6,348.7z M674.5,569.4\n\tc0,0,0,40.9-40.7,40.9H390.1c-40.6,0-40.6-40.9-40.6-40.9v-81.7h56.9v65.4h211.2v-65.4h57L674.5,569.4L674.5,569.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/device.svg
// module id = 1726
// module chunks = 137